import styled from 'styled-components';
import { ActionPanel } from 'components/molecules/action-panel';

const { Popover: CommonPopover } = ActionPanel;

const PopoverComponent = styled(CommonPopover)`
  font-family: var(--ozn-sans);
  height: 407px;
  width: 276px;

  .ant-picker {
    width: 244px;
    margin: 0 var(--popover-spacing) var(--popover-spacing);
  }

  .ant-picker-panel-container {
    box-shadow: none;
    border: none;
    margin-left: calc(-1 * var(--popover-spacing));
    margin-top: 12px;
    border-top: 1px solid var(--border-color);
    border-radius: 0;
  }

  .ant-picker-panel {
    border-bottom: none;
  }

  .ant-picker-date-panel {
    width: 276px;
  }
`;

const Popover: typeof CommonPopover = PopoverComponent as any;

Popover.Title = CommonPopover.Title;

export { Popover };
